import HttpService from "./htttp.service";

class KarkunService {
  endpoint = 'karkuns';

  getAll = async (payload = null) => {
    return await HttpService.get(`${this.endpoint}/`, payload);
  };

  getById = async (id) => {
    return await HttpService.get(`${this.endpoint}/${id}`);
  };

  getByCount = async (payload) => {
    return await HttpService.get(`${this.endpoint}/karkuncount`, payload);
  };

  getnewkarkarkuns = async (payload) => {
    return await HttpService.get(`${this.endpoint}/newkarkuncount`, payload);
  };

 getSuggestedIdByCenter = async (centerId) => {
    return await HttpService.get(`${this.endpoint}/karkuns/suggest-id/${centerId}`);
  }



  getByCenter = async (id) => {
    if (!id || typeof id !== "string") {
      return console.error("ID not found or invalid");
    }
    console.log("Fetching karkuns for ID:", id);
    return await HttpService.get(`${this.endpoint}/karkuns/${id}`);
  };


  create = async (payload) => {
    return await HttpService.post(`${this.endpoint}/add`, payload);
  };

  import = async (payload) => {
    return await HttpService.post(`${this.endpoint}/import`, payload, {
    });
  };


  update = async (id, payload) => {
    return await HttpService.put(`${this.endpoint}/${id}`, payload);
  }

  delete = async (id) => {
    return await HttpService.delete(`${this.endpoint}/${id}`);
  }

  verifyDevice = async (id, payload = {}) => {
    return await HttpService.post(`${this.endpoint}/verify-device?id=${id}`,payload,{ withCredentials: true }
    );
  };



}

export default new KarkunService();
